"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTickClassname = exports.getTruncatedAxisLabel = exports.getAxisPropertiesByType = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
exports.getAxisPropertiesByType = function (axisOrientation, height, width, axisExtension, scale, axisLabelPadding) {
    var tickLabelPadding;
    var axisHeight;
    var axisProperties = {
        tickSize: 0,
        axisTransformation: '',
        axisLabelTransformation: '',
        tickLabelDominantBaseline: '',
        tickLabelTransform: '',
        line: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 0,
        },
        scaledAxis: d3.axisBottom(scale),
    };
    switch (axisOrientation) {
        case 'BOTTOM':
            tickLabelPadding = 8;
            axisHeight = 40;
            axisProperties.scaledAxis = d3.axisBottom(scale);
            axisProperties.tickSize = -height;
            axisProperties.axisTransformation = "translate(0, " + height + ")";
            axisProperties.axisLabelTransformation = "translate(" + axisLabelPadding + ", " + (height + axisHeight) + ")";
            axisProperties.tickLabelDominantBaseline = 'middle';
            axisProperties.tickLabelTransform = "translate(0, " + tickLabelPadding + ")";
            axisProperties.line = {
                x1: 0,
                x2: width + axisExtension,
                y1: height,
                y2: height,
            };
            return axisProperties;
        case 'LEFT':
            tickLabelPadding = 40;
            axisHeight = 70;
            axisProperties.scaledAxis = d3.axisLeft(scale);
            axisProperties.tickSize = -width;
            axisProperties.axisTransformation = "translate(0, 0)";
            axisProperties.axisLabelTransformation = "translate(" + -axisHeight + ", " + (height - axisLabelPadding) + ") rotate(-90)";
            axisProperties.tickLabelDominantBaseline = 'start';
            axisProperties.tickLabelTransform = "translate(-" + tickLabelPadding + ", 0)";
            axisProperties.line = {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: height + axisExtension,
            };
            return axisProperties;
        case 'RIGHT':
            tickLabelPadding = 60;
            axisHeight = 80;
            axisProperties.scaledAxis = d3.axisLeft(scale);
            axisProperties.tickSize = width;
            axisProperties.axisTransformation = "translate(" + width + ", 0)";
            axisProperties.axisLabelTransformation = "translate(" + (width + axisHeight) + ", " + axisLabelPadding + ") rotate(90)";
            axisProperties.tickLabelDominantBaseline = 'start';
            axisProperties.tickLabelTransform = "translate(" + (width + tickLabelPadding) + ", 0)";
            axisProperties.line = {
                x1: width,
                x2: width,
                y1: 0,
                y2: height + axisExtension,
            };
            return axisProperties;
        default:
            axisProperties.scaledAxis = d3.axisLeft(scale);
            axisProperties.tickSize = 0;
            axisProperties.tickLabelTransform = 'translate(0, 0)';
            axisProperties.axisTransformation = 'translate(0, 0)';
            axisProperties.tickLabelDominantBaseline = 'middle';
            axisProperties.axisLabelTransformation = "translate(" + tickLabelPadding + ", 0)";
            axisProperties.line = {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 0,
            };
            return axisProperties;
    }
};
exports.getTruncatedAxisLabel = function (maxNumberChars, axisLabel) {
    var truncatedEnding = '...';
    return axisLabel.substring(0, maxNumberChars - 3) + truncatedEnding;
};
exports.getTickClassname = function (scale, d, width, height, orientation) {
    var className = 'tick';
    var scaledValue = scale(d) || 0;
    if (orientation === 'BOTTOM' && (scaledValue > width || scaledValue < 0)) {
        className = 'tick_out_of_range';
    }
    else if ((orientation === 'LEFT' || orientation === 'RIGHT') &&
        (scaledValue > height || scaledValue < 0)) {
        className = 'tick_out_of_range';
    }
    return className;
};
